<template>
  <div class="container container-720">
    <Card v-if="isReady">
      <Header class="sub-header" style="margin-bottom:32px;">
        <h3 style="text-align:center;">Join as host</h3>
      </Header>
      <Form :model="form" label-position="top">
        <FormItem label="Name">
          <Input v-model="form.name" placeholder></Input>
        </FormItem>
        <FormItem label="Email">
          <Input v-model="form.email" placeholder></Input>
        </FormItem>
        <FormItem label="Organization">
          <Input v-model="form.organization" placeholder></Input>
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            @click="join()"
            style="float:right;"
            v-if="!$data.isLoginPending"
          >Login</Button>
          <Button
            type="primary"
            style="float:right;"
            disable
            v-if="$data.isLoginPending"
          >Please wait...</Button>
        </FormItem>
      </Form>
    </Card>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import CryptoJS from "crypto-js";

export default {
  name: "Login",
  data() {
    return {
      form: {},
      isLoginPending: false,
      isReady: false
    };
  },
  computed: {
    ...mapGetters("webcast", {
      webcast: "getCopy"
    })
  },
  methods: {
    ...mapActions("webcast", {
      getWebcastAction: "get"
    }),
    ...mapActions("stream", {
      findStreamAction: "find",
      createStreamAction: "create",
      updateStreamAction: "update",
      deleteStreamAction: "remove"
    }),
    ...mapActions("account", {
      findAccounts: "find",
      setCurrentAccount: "setCurrent"
    }),
    ...mapActions("users", {
      createUserAction: "create",
      updateUserAction: "patch",
      getUserAction: "get",
      findUserAction: "find"
    }),
    ...mapActions("auth", ["authenticate"]),
    ...mapActions("appsettings", {
      updateAppSettings: "patch"
    }),
    createUser() {
      this.$set(this.$data, "isLoginPending", true);

      const params = {
        fullName: this.$data.form.name,
        email: this.$data.form.email,
        password: CryptoJS.SHA256(this.form.email + this.form.name).toString(),
        role: "user"
      };
      this.createUserAction(params)
        .then(response => {
          this.$set(this.$data, "isPending", false);
          let pass = CryptoJS.SHA256(
            this.form.email + this.form.name
          ).toString();
          this.login(this.form.email, pass);
        })
        .catch(error => console.log(error));
    },
    join() {
      /* Check if it's a new user*/
      this.findUserAction({ query: { email: this.form.email } }).then(
        userList => {
          if (userList.total >= 1) {
            let pass = CryptoJS.SHA256(
              this.form.email + this.form.name
            ).toString();
            this.login(this.form.email, pass);
          } else {
            console.log("we have the user");
            this.createUser();
          }
        }
      );
    },
    login(email, password) {
      this.$set(this.$data, "isLoginPending", true);

      this.authenticate({
        strategy: "local",
        email: email,
        password: password
      })
        .then(response => {
          this.$router.replace("/publisher/" + this.webcast._id);
        })
        .catch(err => {
          if (err.name == "NotAuthenticated") {
            this.$Message.error("Wrong email or password");
          } else {
            this.$Message.error(err.message);
          }
          this.$data.isLoginPending = false;
        });
    }
  },
  created() {
    this.getWebcastAction(this.$router.currentRoute.params.id).then(webcast => {
      console.log(webcast);
      this.setCurrentAccount(webcast.accountId).then(response => {
        console.log(response);
        this.$cookies.set("currentAccount", webcast.accountId);
        this.$data.isReady = true;
      });
    });
  }
};
</script>

<style>
</style>
